import { cancellationSubList } from "constants/ReducerConstants/Constants";

const initialState = {
  cancellationSubList: {},
};

export const CancellationSubListReducer = (state = initialState, action) => {
  switch (action.type) {
    case cancellationSubList:
      return { ...state, cancellationSubList: action.payload };
    default:
      return state;
  }
};
